export default __webpack_public_path__ + "static/media/03_AnimateByColumnsMovie_Left.93967c27.mp4";